import React from "react";

const DropdownV2 = ({
  id,
  handleChange,
  placeholder,
  data,
  width,
  value,
  bgColor = "blackish",
}) => {
  return (
    <div className={`${width}`}>
      <select
        className={`bg-${bgColor} p-2 w-full focus:outline-none text-white text-[14px] font-medium mt-2 leading-4 rounded-md h-10 placeholder:text-greyish`}
        onChange={handleChange}
        placeholder={placeholder}
        value={value}
      >
        <option>Select</option>
        {id === "language"
          ? data?.map((item, index) => (
              <option key={index}>
                {item?.name} - {item?.language}
              </option>
            ))
          : id === "layout"
          ? data?.map((item, index) => (
              <option key={index} className="w-full" value={item?._id}>
                {item?.layout_name}
              </option>
            ))
          : data?.map((item, index) => <option key={index}>{item}</option>)}
      </select>
      <p className="text-white text-xs pl-2 opacity-60 pt-1">Select from Dropdown</p>
    </div>
  );
};

export default DropdownV2;
